"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  List: true
};
exports.default = exports.List = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _ListGroup = require("./_ListGroup");
var _ListItem = require("./_ListItem");
var _ListContext = require("./_ListContext");
var _List = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List.css") : void 0);
var _List2 = require("./List.types");
Object.keys(_List2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _List2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _List2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-list';
/**
 * The **List** component can be used to display a homogeneous set of basic data
 * with a single-level hierarchy.
 */
const List = exports.List = Object.assign(/*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _a = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(List, props)) : props,
    {
      bordered,
      children,
      className,
      type = 'unordered',
      transparent,
      label
    } = _a,
    otherProps = __rest(_a, ["bordered", "children", "className", "type", "transparent", "label"]);
  const classnames = _bind.default.bind(_List.default);
  const isUsingGroups = _react.default.Children.toArray(children).some(child => {
    var _a;
    return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'List.Group';
  });
  const listContextValue = (0, _react.useMemo)(() => ({
    bordered,
    transparent,
    isUsingGroups,
    type
  }), [bordered, isUsingGroups, type]);
  const classes = classnames(CSS_BLOCK, className);
  return /*#__PURE__*/_react.default.createElement(_ListContext.ListContext.Provider, {
    value: listContextValue
  }, /*#__PURE__*/_react.default.createElement(_ListGroup.ListGroup, Object.assign({}, otherProps, {
    className: classes,
    isRoot: true,
    ref: ref,
    heading: label
  }), children));
}), {
  displayName: 'List',
  Group: _ListGroup.ListGroup,
  Item: _ListItem.ListItem
});
var _default = exports.default = List;